/*
 * @Author: DQL
 * @Date: 2020-03-05 17:12:52
 * @LastEditors: cgh
 * @LastEditTime: 2023-06-06 16:13:08
 * @Description: file content
 */
import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import config from './config'; // 系统配置文件
import router from './router.js'; // 主路由配置
import store from './store.js'; // 数据管理
import KestrelCoreUI from 'kestrel-core-ui'; // core-ui库
// import 'kestrel-core-ui/lib/kestrel-core-ui.css'; // core-ui库样式
// import 'kestrel-iconfont/lib/kestrel-iconfont.css'; // 图标库
import kestrelComponents from 'kestrel-components'; // 组件库
import HMAxiosInterceptor from './interceptor';
import * as echarts from 'echarts';
import validUtils from '@/validUtils.js';
import utils from '@/utils.js';
import './style.scss';
import '@/banner.js';
// 自定义过滤器
import '@/filter';
import '@/directive';
import '@/features/components/component.js';
import { tableWidthConfig, globalConfig } from '@/features/feature.common.config'; // 系统配置文件

// .finally is not a function —— 解决低版本浏览器axios不支持finally
// 参考：https://segmentfault.com/a/1190000015550213
require('promise.prototype.finally').shim();

Vue.config.productionTip = false;

// 应用ui库
Vue.use(KestrelCoreUI, {
  size: 'mini'
});

Vue.use(kestrelComponents);
Vue.prototype.$echarts = echarts;

// 调用ui库方法，配置请求拦截器
HMAxiosInterceptor(axios, router, {
  serverHeaderTokenName: config.serverHeaderTokenName,
  localTokenName: config.localTokenName
});

Vue.prototype.$config = config;
Vue.prototype.$validUtils = validUtils;
Vue.prototype.$utils = utils;

Vue.prototype.$axios = axios;

Vue.prototype.$commonConfig = {
  tableWidthConfig,
  globalConfig
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
